<template>
    <div id="app">
        <div v-if="requirePin" class="content align-center">
            <form v-on:submit="enterPin">
                <div class="field">
                    <label>What's your PIN?</label>
                    <br>
                    <br>
                    <input type="tel" v-model="newPin" class="pin" placeholder="****" maxlength="4" autofocus>
                </div>
                <div class="field">
                    <button v-if="loadingPin" disabled="disabled">
                        Loading...
                    </button>
                    <button v-else type="submit">
                        Enter PIN
                    </button>
                </div>
            </form>
        </div>
        <div v-else>
            <div v-if="loading" class="loading content align-center">
                <p>Loading...</p>
            </div>
            <router-view v-else :app="app" />
        </div>
    </div>
</template>

<style lang="scss">
@import "./index.scss";
</style>

<script>
import Vue           from 'vue';
import async         from 'async';
import localForage   from 'localforage';
import uniqId from 'uniq-id';
import xhr           from '@/components/app/ajax';
import seed          from '@/components/app/seed';

var POLL = 60000,
    generateId = uniqId.generateUUID('xxxxyxxxxyxxxxyxxxxyxxxxyxxxxyxxxxyxxxxy', 32),
    LINKED_ATTRIBUTES = {
        locations: ['peopleIds'],
        people: [],
        days: ['locationId'],
        staff: []
    },
    POLLER, PIN;

function singularize(type) {
    if (type === 'people') {
        return 'person';
    }

    if (type === 'staff') {
        return 'staff';
    }

    return type.slice(0, -1);
}

export default {
    data() {
        var _ = this;

        window.app = _;

        return {
            app: _,
            logo: window.logo || '/img/logo.svg',
            loading: true,
            user: undefined,
            requirePin: undefined,
            loadingPin: false,
            newPin: '',
            hints: {},
            locations: [],
            people: [],
            days: [],
            staff: [],
            unsaved: [],
            // isOnline: window.navigator.onLine,
            api: false,
            store: localForage.createInstance({
                name: 'attend'
            })
        };
    },
    mounted() {
        var _ = this;

        if (!window.API_URL) {
            alert('No API URL supplied');
            return;
        }

        _.applyHints(function() {
            _.saveUnsavedRemote(function() {
                _.fetch(function() {
                    _.applySeed(function() {
                        _.loading = false;

                        setTimeout(function() {
                            _.poll();
                        }, POLL);
                    });
                });
            });
        });

        window.addEventListener('online',  function() {
            _.poll();
        });
    },
    computed: {
        selectedLocation() {
          var _ = this;

          return _.locations.find(function(location) {
              return location.id + '' === _.$route.params.id + '';
          });
        },
        sortedLocations() {
            var _ = this;

            return _.locations.sort(_.sortByName);
        }
    },
    methods: {
        // todo: Days model

        enterPin(e) {
            var _ = this;
            _.loadingPin = true;

            setTimeout(function() {
                PIN = _.newPin;
                _.newPin = '';

                if (typeof _.requirePin === 'function') {
                    _.requirePin.call(_);
                }

                _.loadingPin = false;
                _.requirePin = undefined;
            }, 100);

            e.preventDefault();
        },

        hideHint(type) {
            var _ = this;
            Vue.set(_.hints, type, true);
            _.store.setItem('hint-' + type, true);
        },

        poll() {
            var _ = this;

            clearTimeout(POLLER);

            _.saveUnsavedRemote(function() {
                _.fetchRemote(function() {
                    _.afterFetchItems(function() {
                        POLLER = setTimeout(function() {
                            _.poll();
                        }, POLL);
                    });
                });
            });
        },

        applySeed(done) {
            var _ = this;

            if (_.locations.length || _.people.length) return done();

            _.locations = seed.locations;
            _.people = seed.people;
            _.days = seed.days;
            _.staff = seed.staff;

            done();
        },

        merge(a, b) {
            if (typeof b !== 'object') return;

            var item, key;

            for (var i = b.length - 1; i >= 0; i--) {
                item = a.find(function(c) {
                    return c.id === b[i].id;
                });

                if (item) {
                    for (key in item) {
                        b[key] = item[key];
                    }
                } else {
                    a.push(b[i]);
                }
            }
        },

        fetchLocal(done) {
            var _ = this;

            async.eachSeries(['locations', 'people', 'days', 'staff', 'unsaved'], function(collection, next) {
                _.store.getItem(collection, function(err, value) {
                    _.merge(_[collection], value || []);
                    next();
                });
            }, function() {
                done();
            });
        },

        fetchRemote(done) {
            var _ = this;

            async.eachSeries(['locations', 'people', 'days', 'staff'], function(collection, next) {
                _.ajax('GET', '/' + collection, function(err, value) {
                    _.merge(_[collection], value || []);
                    next();
                });
            }, function() {
                done();
            });
        },

        buildItem(collection, item) {
            item.id = item.id || generateId();
            item._collection = item._collection || collection;

            return item;
        },

        fetch(done) {
            var _ = this;

            _.fetchLocal(function() {
                _.fetchRemote(function() {
                    _.afterFetchItems(function() {
                        done();
                    });
                });
            });
        },

        afterFetchItems(done) {
            var _ = this;

            async.eachSeries(['locations', 'people', 'days', 'staff'], function(collection, next) {
                var arr = _[collection];

                for (var i = arr.length - 1; i >= 0; i--) {
                    _.buildItem(collection, arr[i]);
                    arr[i]._lastUpdatedAt = arr[i].updatedAt;
                }

                next();
            }, function() {
                done();
            });
        },

        ajax(method, url, data, item, done) {
            if (typeof data === 'function') {
                done = data;
                data = undefined;
            }

            if (typeof item === 'function') {
                done = item;
                item = undefined;
            }

            var _ = this;

            _.confirmPin(function() {
                xhr({
                    method: method,
                    url: window.API_URL + '/' + PIN + url,
                    data: data,
                    beforeSend(a) {
                        a.setRequestHeader('Authorization', 'Basic ' + btoa(PIN));
                    },
                    success(data) {
                        if (item && data[item._constructor]) {
                            _.merge([item], [data[item._constructor]]);
                        }

                        if (typeof done === 'function') {
                            done(undefined, data);
                        }
                    },
                    error(err) {
                        if (err) {
                            if (method !== 'GET') {
                                _.unsaved.push([
                                    method,
                                    url,
                                    JSON.parse(JSON.stringify(data)),
                                    item ? { _collection: item._collection, id: item.id } : undefined
                                ]);

                                _.saveUnsavedLocal();
                            }

                            if (err.status > 200) {
                                console.error(err);

                                if (err.status === 401) {
                                    PIN = undefined;

                                    _.confirmPin(function() {
                                        _.ajax(method, url, data, item, function() {
                                            done();
                                            _.poll();
                                        });
                                    });
                                    return;
                                }
                            }
                        }

                        if (typeof done === 'function') {
                            done(err);
                        }
                    }
                });
            });
        },

        applyHints(done) {
            var _ = this;

            async.eachSeries(['lock'], function(type, next) {
                _.store.getItem('hint-' + type, function(err, value) {
                    Vue.set(_.hints, type, !!value);
                    next();
                });
            }, function() {
                done();
            });
        },

        confirmPin(done) {
            var _ = this;

            if (!PIN) {
                _.requirePin = done;
            } else {
                if (typeof done === 'function') {
                    done();
                }
            }
        },

        save(item, attr, done) {
            if (typeof attr === 'function') {
                done = attr;
                attr = undefined;
            }

            if (typeof item === 'function') {
                done = item;
                item = undefined;
            }

            if (typeof item === 'object') {
                item._lastUpdatedAt = Math.round(Date.now() / 1000);
            }

            var _ = this;

            _.saveLocal(item, attr, function() {
                _.saveRemote(item, attr, done);
            });
        },

        isPersisted(item) {
            return !item._lastUpdatedAt || (item.updatedAt && item.updatedAt >= item._lastUpdatedAt);
        },

        saveUnsavedRemote(done) {
            var _ = this,
                saves = [],
                args;

            while (_.unsaved.length) {
                args = _.unsaved.shift();
                saves.push([args[0], args[1], args[2], args[3] ? _[args[3]._collection].find(function(i) {
                      return i.id + '' === args[3].id + '';
                }) : undefined]);
            }

            _.saveUnsavedLocal();

            async.eachSeries(saves, function(a, next) {
                _.ajax(a[0], a[1], a[2], a[3], next);
            }, function() {
                done();
            });
        },

        saveUnsavedLocal(done) {
            var _ = this;
            _.store.setItem('unsaved', _.unsaved, done);
        },

        saveLocal(item, attr, done) {
            if (typeof attr === 'function') {
                done = attr;
                attr = undefined;
            }

            if (typeof item === 'function') {
                done = item;
                item = undefined;
            }

            var _ = this;

            async.eachSeries(['locations', 'people', 'days', 'staff'], function(collection, next) {
                _.store.setItem(collection, _[collection], function() {
                    next();
                });
            }, function() {
                done();
            });
        },

        saveRemote(item, attr, done) {
            if (typeof attr === 'function') {
                done = attr;
                attr = undefined;
            }

            if (typeof item === 'function') {
                done = item;
                item = undefined;
            }

            var _ = this;

            if (typeof item === 'object') {
                _.saveRemoteItem(item, attr, done);
                return;
            }

            async.eachSeries(['locations', 'people', 'days', 'staff'], function(collection, next) {
                async.eachSeries(_[collection], function(location, n) {
                    _.saveRemoteItem(location, n);
                }, function() {
                    next();
                });
            }, function() {
                if (typeof done === 'function') {
                    done();
                }
            });
        },

        saveRemoteItem(item, attr, done) {
            if (typeof attr === 'function') {
                done = attr;
                attr = undefined;
            }

            var _ = this,
                args = {};

            if (attr) {
                args[singularize(item._collection)] = {};
                args[singularize(item._collection)].id = item.id;
                args[singularize(item._collection)][attr] = item[attr];
            } else {
                args[singularize(item._collection)] = item;
            }

            _.ajax('POST', '/' + item._collection, args, item, function(err, value) {
                _.swapIds(item, value);

                if (typeof done === 'function') {
                    done(err, value);
                }
            });
        },

        swapIds(local, remote) {
            if (remote && local.id !== remote.id) {
                var _ = this,
                    oldId = local.id,
                    key;

                local.id = remote.id;

                for (key in LINKED_ATTRIBUTES) {
                    var attr = local._collection + 'Ids';

                    if (LINKED_ATTRIBUTES[key].indexOf(attr) !== -1) {
                        _[key].forEach(function(item) {
                            var index = item[attr].indexOf(oldId);

                            if (index !== -1) {
                                item[attr][index] = remote.id;
                                _.saveRemoteItem(item);
                            }
                        });
                    }

                    attr = singularize(local._collection) + 'Id';

                    if (LINKED_ATTRIBUTES[key].indexOf(attr) !== -1) {
                        _[key].filter(function(item) {
                            if (item[attr] === oldId) {
                                item[attr] = remote.id;
                                _.saveRemoteItem(item);
                            }
                        });
                    }
                }
            }
        },

        addPersonByName(location, name, date, component) {
            var _ = this,
                person = _.buildItem('people', {
                    name: name
                });

            _.people.push(person);

            location.peopleIds.push(person.id);

            if (component) {
                component.q = '';
            }

            _.save(person, function() {
                _.save(location, function() {
                    if (date) {
                        _.present(location, person, date);
                    }
                });
            });
        },
        prepDate(date) {
            var _ = this;

            if (date instanceof Date) {
                return date.getFullYear() + '-' + _.zeroPad(date.getMonth() + 1) + '-' + _.zeroPad(date.getDate());
            }

            return date;
        },
        formatDate(date) {
            var splat = date.toDateString().split(' ');
            return splat[1] + ' ' + splat[2];
        },
        isPresent(location, person, d) {
            if (location instanceof Array) {
                for (var i = location.length - 1; i >= 0; i--) {
                    if (this.isPresent(location[i], person, d)) {
                        return true;
                    }
                }

                return false;
            }

            return false;

            // var _ = this,
            //     date = _.prepDate(d),
            //     lastAction = _.days.filter(function(action) {
            //         return (
            //             action.personId === person.id &&
            //             action.locationId === location.id &&
            //             date === action.date
            //         );
            //     }).sort(function(a, b) {
            //         if (a.updatedAt > b.updatedAt) return -1;
            //         if (a.updatedAt < b.updatedAt) return  1;
            //         return 0;
            //     })[0];

            // return lastAction ? lastAction.present : false;
        },
        present(location, person, d) {
            var _ = this,
                date = _.prepDate(d),
                present = !_.isPresent(location, person, date),
                action = _.buildItem('days', {
                    name: [person.id, location.id, date, present].join(','),
                    personId: person.id,
                    locationId: location.id,
                    date: date,
                    present: present
                });

            _.days.push(action);
            _.save(action);
        },

        addLocation() {
            var _ = this,
                id = _.locations.length + 1,
                location = _.buildItem('locations', {
                    name: 'Location ' + id,
                    peopleIds: []
                });

            _.locations.push(location);
            _.$router.push({ name: 'locationEdit', params: { id: location.id } });
            _.save(location);
        },
        addStaff() {
            var _ = this,
                id = _.locations.length + 1,
                member = _.buildItem('staff', {
                    name: 'Staff ' + id
                });

            _.staff.push(member);
            _.save(member);
        },
        remove(arr, item, type, goHome, goBack) {
            var _ = this;

            if (confirm('Are you sure you want to delete this ' + type + '?')) {
                // todo: mark as archived
                // todo: remove from all connected arrays
                arr.splice(arr.indexOf(item), 1);

                if (goHome) {
                    _.$router.push('/');
                } else if (goBack) {
                    _.$router.go(-1);
                }
            }
        },
        star(location, person) {
            var _ = this;

            if (_.isStarred(location, person)) {
                location.peopleIds.splice(location.peopleIds.indexOf(person.id), 1);
            } else {
                location.peopleIds.push(person.id);
            }

            _.save(location, 'peopleIds');
        },
        isStarred(location, person) {
            location.peopleIds = location.peopleIds || [];
            return location.peopleIds.indexOf(person.id) !== -1;
        },
        zeroPad(n, width, z) {
            width = width || 2;
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        },
        sortByName(a, b) {
            return ('' + a.name).localeCompare(b.name);
        },
        sortBycollection(a, b) {
            return ('' + a.location.name).localeCompare(b.location.name);
        }
    }
};
</script>
